import { render, staticRenderFns } from "./PostDice.vue?vue&type=template&id=46ffe1b2&scoped=true&"
import script from "./PostDice.vue?vue&type=script&lang=js&"
export * from "./PostDice.vue?vue&type=script&lang=js&"
import style0 from "./PostDice.vue?vue&type=style&index=0&id=46ffe1b2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46ffe1b2",
  null
  
)

export default component.exports